import { copyGroups } from '../constants'
import { getCopiesByGroup } from '../helpers'
import { fakeLineItem, reasonKeyMap } from './constants'

export const getNotReturnableReason = fullKey => reasonKeyMap[fullKey] || 'disabled'

export const mapProductToLineItem = product => {
  if (!product) return fakeLineItem

  const firstVariant = product.inventory_items?.[0]

  return {
    product: {
      name: product.title,
      image_url: product.image_url,
    },
    variant: {
      image_url: firstVariant?.image_url,
    },
    sku: firstVariant?.sku,
    productIndex: 1,
  }
}

const mapCustomMessage = (fullKey, customCopy) => {
  return {
    key: fullKey,
    title: customCopy.title,
    message: customCopy.message,
  }
}

const getCustomMessages = langCopies => {
  if (!langCopies) return []

  const blockedProductKeys = getCopiesByGroup(copyGroups.blockedProducts).map(copy => copy.key)

  return blockedProductKeys
    .filter(fullKey => langCopies[fullKey]?.message)
    .map(fullKey => mapCustomMessage(fullKey, langCopies[fullKey]))
}

export const buildMerchantInfoForPreview = (customCopies, lang, merchant) => {
  return {
    contact_email: merchant.contact_email,
    contact_url: merchant.contact_url,
    preferences: {
      contact_method: merchant.preferences.contact_method,
      custom_messages: {
        [lang]: getCustomMessages(customCopies?.[lang]),
      },
    },
  }
}
